import {Box} from "@mui/joy";
import {ActiveUser} from "@/components/ActiveUser.jsx";
import {SideBySideLayout} from "@/components/layouts/SideBySideLayout.jsx";
import {OnboardingTip} from "@/components/OnboardingTip.jsx";
import {Logo} from "@/components/Logo.jsx";

export function OnboardingLayout({ children, title, subtitle }) {
  return (
    <SideBySideLayout left={
      <>
        <Box component="header" sx={{pl: {xs: 0, lg: 4.25}, py: {xs: 2, lg: 4.3}}}>
          <Logo />
        </Box>
        <Box
          component="main"
          sx={{
            my: 'auto',
            py: 2,
            pb: 7,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            width: 540,
            maxWidth: '100%',
            mx: 'auto',
            borderRadius: 'sm',
          }}
        >
          {children}
        </Box>
        <Box sx={{py: 2}}>
          <ActiveUser/>
        </Box>
      </>
    } right={
      <OnboardingTip
        title={title}
        subtitle={subtitle}
      />
    }/>
  );
}
